/**
 * Single source of truth for the chart UI-chrome palette (toolbar, popovers,
 * sync toggles, layout picker, EdgeChart overlays). These are the hardcoded
 * pro-charting-flavoured dark values that were previously copy-pasted into a
 * per-component `const C = { …hex… }` in five files.
 *
 * Consolidating them here removes the drift (five near-identical objects) while
 * keeping the rendered colours byte-for-byte identical. A future theming pass
 * can map these onto the `hsl(var(--chart-*))` tokens (see `apps/frontend`'s
 * `index.css`) so the chrome follows light/dark like the drawers already do —
 * that's a deliberate visual change and is intentionally NOT done here.
 */
export const CHART_COLORS = {
  /** Canvas / app background (`#131722`). */
  canvas: '#131722',
  /** Raised surface — popovers, menus, toggle track background (`#1e222d`). */
  surface: '#1e222d',
  /** Primary text (`#d1d4dc`). */
  text: '#d1d4dc',
  /** Secondary / muted text and off-state toggle thumb (`#787b86`). */
  textMuted: '#787b86',
  /** Hairline borders and off-state toggle track (`#2a2e39`). */
  border: '#2a2e39',
  /** Accent / active / on-state toggle track (`#2962ff`). */
  primary: '#2962ff',
  /** Translucent accent for hover fills (`rgba(41,98,255,0.15)`). */
  primaryFade: 'rgba(41,98,255,0.15)',
  /** On-state toggle thumb (`#ffffff`). */
  white: '#ffffff',
} as const

/**
 * The chart's UI font stack — used by the canvas overlays (crosshair time label,
 * earnings tooltip, EdgeChart labels) so their text matches the app shell.
 * Previously inlined as an identical string in three components.
 */
export const CHART_FONT_FAMILY = 'IBM Plex Sans, ui-sans-serif, system-ui, sans-serif'
